module.exports = __webpack_public_path__ + "img/spv.53bb44f8.png";